// extracted by mini-css-extract-plugin
module.exports = {"link":"_35CUM","root":"_1cAdt","label":"_31f2m"};